import React from "react";
//styles
import "./Card.scss";
//assets
import icon_bank from "../../assets/icons/icon-bank.svg";

export default function Card(props) {
	return (
		<div
			className="bank-card container--default p-3"
			onClick={() => {
				props.click("CardModal");
			}}
		>
			<p className="bank-card__number">
				●●●●&nbsp;&nbsp;&nbsp;●●●●&nbsp;&nbsp;&nbsp;●●●●&nbsp;&nbsp;{props.data.last4}
			</p>
			<div className="d-flex justify-content-between align-items-end">
				<div>
					<p className="bank-card__expires">
						{props.data.exp_month} /{props.data.exp_year}{" "}
					</p>
					<p className="bank-card__name mt-3">{props.data.user?.lastName} {props.data.user?.firstName}</p>
				</div>
				<img src={icon_bank} alt="" className="bank-card__logo" />
			</div>
		</div>
	);
}
